import { render, staticRenderFns } from "./AUserSnippetBase.vue?vue&type=template&id=06c84c82&scoped=true&"
import script from "./AUserSnippetBase.vue?vue&type=script&lang=ts&"
export * from "./AUserSnippetBase.vue?vue&type=script&lang=ts&"
import style0 from "./AUserSnippetBase.vue?vue&type=style&index=0&id=06c84c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c84c82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VIcon,VProgressCircular})
